"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LanguageSelector = void 0;
var UserAction = _interopRequireWildcard(require("@ori-events/user-action"));
var _mui = require("@ori-ui/mui");
var _environment = require("@ori/environment");
var _i18n = require("@ori/i18n");
var _languageSwitcher = require("@ori/language-switcher");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = _interopRequireWildcard(require("react"));
var _hooks = require("../../hooks");
var _components = require("./components");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function (e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
    return f;
  })(e, t);
}
const LanguageSelector = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    language
  } = (0, _i18n.useLanguage)();
  const {
    languageConfiguration,
    languages
  } = (0, _hooks.useFooter)();
  const onChangeLanguage = (0, _react.useCallback)(nextLanguage => () => {
    if (nextLanguage.code !== language) {
      UserAction.dispatch([_constants.USER_ACTION_NAME, _constants.USER_ACTION_LOCATION, nextLanguage.code ?? '']);
      (0, _languageSwitcher.changeLanguage)(nextLanguage, language, tenant);
    }
  }, [language, tenant]);
  if (languages.length === 0 || !languageConfiguration?.countryLabel || !languageConfiguration.currentCountry) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": getTestId(_constants.LANGUAGE_SELECTOR),
    children: [languages.length > 1 && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
      display: "inline-block",
      children: [languageConfiguration.languageLabel, ":", ' ', languages.map((lang, index) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.default.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.LanguageName, {
          isActive: lang.code === language,
          role: "button",
          tabIndex: 0,
          onClick: onChangeLanguage(lang),
          onKeyDown: onChangeLanguage(lang),
          children: lang.name
        }), languages.length - 1 === index ? null : ' / ']
      }, lang.code || index))]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.CountryInfo, {
      label: languageConfiguration.countryLabel,
      value: languageConfiguration.currentCountry
    })]
  });
};
exports.LanguageSelector = LanguageSelector;